export default "/images/e0a43c37c8297558b93e91644fb7eec6.avif";